import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './../store';

export const slice = createSlice({
	name: 'payment',
	initialState: {
		skipPayment: false,
	},
	reducers: {
		setSkipPayment: (state, action) => {
			console.log('action pay action--' + action.payload);
			state.skipPayment = action.payload;
		},
	},
});

export const { setSkipPayment } = slice.actions;

export const selectPayment = (state: RootState) => state.payment;
export default slice.reducer;
